import { Keyboard } from "../../../foundation/enums";
import { cmdKey } from "../../../foundation/utils/keyboard";

function getKeyboardInfo(ev: MouseEvent | KeyboardEvent) {
    return {
        shiftPressed: ev.shiftKey,
        cmdPressed: cmdKey(ev),
        altPressed: ev.altKey,
        aPressed: (ev as KeyboardEvent).key === Keyboard.Key.a,
        upPressed: (ev as KeyboardEvent).key === Keyboard.Key.ArrowUp,
        downPressed: (ev as KeyboardEvent).key === Keyboard.Key.ArrowDown,
        leftPressed: (ev as KeyboardEvent).key === Keyboard.Key.ArrowLeft,
        rightPressed: (ev as KeyboardEvent).key === Keyboard.Key.ArrowRight,
        enterPressed: (ev as KeyboardEvent).key === Keyboard.Key.Enter
    };
}

function findItemInRange(from: number, to: number, callback: (item: number) => boolean): number | null {
    const range = Math.abs(from - to);
    const direction = from < to ? 1 : -1;

    for (let i = 0; i <= range; i++) {
        const current = from + i * direction;
        if (callback(current)) {
            return current;
        }
    }

    return null;
}

function findFirstSelectedItemInRange(selection: Set<number>, from: number, to: number): number | null {
    const foundItem = findItemInRange(from, to, (item: number) => selection.has(item));
    return foundItem;
}

function findFirstUnselectedItemInRange(selection: Set<number>, from: number, to: number): number | null {
    const foundItem = findItemInRange(from, to, (item: number) => !selection.has(item));
    return foundItem;
}

function removeItemsInRange(selection: Set<number>, from: number, to: number): void {
    const start = Math.min(from, to);
    const end = Math.max(from, to);

    for (let i = start; i <= end; i++) {
        selection.delete(i);
    }
}

function selectItemsInRange(selection: Set<number>, from: number, to: number): void {
    const start = Math.min(from, to);
    const end = Math.max(from, to);

    for (let i = start; i <= end; i++) {
        selection.add(i);
    }
}

export {
    getKeyboardInfo,
    findItemInRange,
    findFirstSelectedItemInRange,
    findFirstUnselectedItemInRange,
    removeItemsInRange,
    selectItemsInRange
};
